import React from 'react';
import { Row, Col } from 'antd';
import {
	XThemeVoiceAssTableCard,
	XVSLottie,
	XThemeVSSetViewPort,
	XThemeVSScrollContainer,
	XThemeVSGenerateAL,
} from '../../VoiceAssistanceStyle';
import InitialBatchLoader from '../../../../json/initial_animation_batch.json';

const VAPayerComparisonLoader = (props) => {
	const { action } = props;
	return (
		<>
			<XThemeVSSetViewPort className="displyBlock">
				<XThemeVSScrollContainer>
					<Row gutter={[15, 15]}>
						<Col xs={24}>
							<div className="hasPadding">
								<Row
									gutter={[15, 15]}
									className="align-items-center justify-content-center"
								>
									<XThemeVSGenerateAL className="h-100">
										<XVSLottie
											className="relativePositions"
											animationData={InitialBatchLoader}
											loop={true}
										/>
									</XThemeVSGenerateAL>
								</Row>
							</div>
						</Col>
					</Row>
				</XThemeVSScrollContainer>
			</XThemeVSSetViewPort>
		</>
	);
};

export default VAPayerComparisonLoader;
